import React, { Component, UIEvent } from "react";
import classnames from "classnames";
import { observable } from "mobx";
import { observer } from "mobx-react";

import * as styles from "./Scrollable.scss";

export interface IScrollableProps {
    dark?: boolean;
    className?: string;
    children?: React.ReactNode;
    preventScroll?: boolean;
    disableScrolling?: boolean;
}

@observer
export class Scrollable extends Component<IScrollableProps> {
    private scrollRef = React.createRef<HTMLDivElement>();

    @observable
    private scrolling: boolean = false;

    public render() {
        const { dark, className, children, preventScroll, disableScrolling } =
            this.props;

        return (
            <div
                className={classnames(
                    styles.scrollable,
                    dark && styles.dark,
                    this.scrolling && styles.scrolling,
                    preventScroll && styles["prevent-scroll"],
                    className,
                )}
            >
                <div
                    ref={this.scrollRef}
                    className={styles.content}
                    onScroll={this.onScroll}
                    style={{ overflowY: disableScrolling ? "hidden" : "auto" }}
                >
                    {children}
                </div>
                <div className={styles.shadow} />
            </div>
        );
    }

    scrollToBottom() {
        if (this.scrollRef && this.scrollRef.current) {
            this.scrollRef.current.scrollTop =
                this.scrollRef.current.scrollHeight;
        }
    }

    scrollToTop() {
        if (this.scrollRef && this.scrollRef.current) {
            this.scrollRef.current.scrollTop = 0;
        }
    }

    private onScroll = (event: UIEvent) => {
        const scrolling = event.currentTarget.scrollTop > 0;
        if (scrolling !== this.scrolling) {
            this.scrolling = scrolling;
        }
    };
}
